import { withPageAuthRequired } from "@common/middleware";
import { NextPage } from "next";
import PlayZoneSSO from "@modules/mgp/components/PlayZoneSSO";
import WhatAreYouAfraidOfSSO from "@modules/mgp/components/WhatAreYouAfraidOfSSO";
import FinancialPlanToolbar from "@modules/financialplan/components/FinancialPlanToolbar";
import FinancialPlanGoals from "@modules/financialplan/components/FinancialPlanGoals";
import FinancialPlanSummary from "@modules/financialplan/components/FinancialPlanSummary";
import FinancialPlanCharts from "@modules/financialplan/components/FinancialPlanCharts";
import { Tabs } from "@modules/financialplan/constants";
import useStore from "@modules/financialplan/state";
import PlanScenarioToggleSwitch from "@modules/financialplan/components/PlanScenarioToggleSwitch";
import { useHousehold } from "@common/queries";
import ZeroState from "@modules/zerostate/components/ZeroState";
import { Typography } from "@earned/core";
import { ZeroStateModules } from "@common/constants";

const FinancialPlanPage: NextPage = () => {
  const { selectedTab } = useStore();
  const { data: household } = useHousehold();

  if (!household) return null;

  return (
    <div className="relative flex flex-1 flex-col">
      {household.isLockedFinancialPlan ? (
        <ZeroState name={ZeroStateModules.FinancialPlan} />
      ) : (
        <div className="flex flex-1 flex-col overflow-y-auto border-primary bg-green-40">
          <div className="md:min-h-24">
            <FinancialPlanToolbar />
          </div>
          {selectedTab === Tabs.PlayZone && (
            <div className="relative h-full overflow-y-auto bg-white">
              <PlayZoneSSO />
            </div>
          )}
          {selectedTab === Tabs.Fears && (
            <div className="relative h-full overflow-y-auto bg-white">
              <WhatAreYouAfraidOfSSO />
            </div>
          )}
          {selectedTab === Tabs.PlanOverview && (
            <div className="flex flex-1 flex-col overflow-y-auto bg-white">
              <div className="border-b border-primary bg-green-40 md:min-h-30">
                <FinancialPlanSummary />
              </div>
              <div className="table h-auto min-h-[448px] border-b border-primary">
                <FinancialPlanCharts />
              </div>
              <div className="grid grid-cols-3">
                <div className="col-span-3 mb-3 flex flex-row justify-between p-10 pb-6">
                  <div className="flex flex-col">
                    <Typography
                      variant="title-xs"
                      weight="medium"
                      color="primary"
                    >
                      Goals
                    </Typography>
                    <Typography variant="body-sm" color="primary">
                      Current Dollars
                    </Typography>
                  </div>
                  <PlanScenarioToggleSwitch />
                </div>
                <div className="col-span-3 border-primary lg:border-r xl:col-span-1">
                  <FinancialPlanGoals goalType="needs" />
                </div>
                <div className="col-span-3 border-primary lg:border-r xl:col-span-1">
                  <FinancialPlanGoals goalType="wants" />
                </div>
                <div className="col-span-3 xl:col-span-1">
                  <FinancialPlanGoals goalType="wishes" />
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default withPageAuthRequired(FinancialPlanPage);
